module.exports = __webpack_public_path__ + "static/media/temescal-sun.bfe618ab.jpg";